<script setup lang="ts">
import { computed } from 'vue';
import { ElConfigProvider } from 'element-plus';
import { ELEMENT_LOCALES } from '@/i18n';
import { useAppStore } from '@/stores/app';

// ElConfigProvider 负责 Element Plus 内置文案（分页、日期选择器等）跟随语言切换
const appStore = useAppStore();
const elementLocale = computed(() => ELEMENT_LOCALES[appStore.locale]);
</script>

<template>
  <ElConfigProvider :locale="elementLocale">
    <RouterView />
  </ElConfigProvider>
</template>
